/**
 * @generated SignedSource<<ffada2c1b8fb91e5d82f2deea78ada9e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ProductType = "community_event" | "course" | "membership_plan" | "pathway" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ProductSettingsFormSaveButton_ProductFragment$data = {
  readonly isInPublishedPathway: boolean;
  readonly type: ProductType;
  readonly " $fragmentType": "ProductSettingsFormSaveButton_ProductFragment";
};
export type ProductSettingsFormSaveButton_ProductFragment$key = {
  readonly " $data"?: ProductSettingsFormSaveButton_ProductFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductSettingsFormSaveButton_ProductFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductSettingsFormSaveButton_ProductFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isInPublishedPathway",
      "storageKey": null
    }
  ],
  "type": "Product",
  "abstractKey": null
};

(node as any).hash = "5466575d0b4662904e5b04ce94b2949d";

export default node;
